var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C2243",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0c.55228475 0 1 .44771525 1 1v6c0 .55228475-.44771525 1-1 1H1c-.55228475 0-1-.44771525-1-1V1c0-.55228475.44771525-1 1-1h6zm-.4 1.4H1.4v5.2h5.2V1.4zM16 0c.5522847 0 1 .44771525 1 1v6c0 .55228475-.4477153 1-1 1h-6c-.55228475 0-1-.44771525-1-1V1c0-.55228475.44771525-1 1-1h6zm-.4 1.4h-5.2v5.2h5.2V1.4zM7 9c.55228475 0 1 .44771525 1 1v6c0 .5522847-.44771525 1-1 1H1c-.55228475 0-1-.4477153-1-1v-6c0-.55228475.44771525-1 1-1h6zm-.4 1.4H1.4v5.2h5.2v-5.2zM16 9c.5522847 0 1 .44771525 1 1v6c0 .5522847-.4477153 1-1 1h-6c-.55228475 0-1-.4477153-1-1v-6c0-.55228475.44771525-1 1-1h6zm-.4 1.4h-5.2v5.2h5.2v-5.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid_view.de28af885ae9f17a282471d5b9d5af48.svg";
export { ForwardRef as ReactComponent };